import { paymentOptionsApiService } from "@api-services/payment-options";
import { PaymentOptionDto } from "@api-types/payment-options/PaymentOptionDto";
import { PaymentOptionsData } from "@data-types/payment-options";
import { getAgencyKey, getApplicationHeaders } from "@utils";
import { localizationService } from "@state";

class PaymentOptionsService {
	get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}${getAgencyKey()}/payment-options`;
	}

	getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	async getFooterMethods(): Promise<PaymentOptionDto[]> {
		const response = await paymentOptionsApiService.getFooterMethods();

		return response;
	}

	async getPaymentOptions(): Promise<PaymentOptionsData> {
		const response = await paymentOptionsApiService.getPaymentOptions();

		const mappedResponse = response.map(
			(item: PaymentOptionDto): PaymentOptionDto => {
				switch (item.depositDuration) {
					case 0: {
						item.displayDepositDuration = localizationService.t(
							"PAYMENT_OPTIONS.DURATION_PERIOD.IMMEDIATELY"
						);
						break;
					}
					case 1: {
						item.displayDepositDuration = `${
							item.depositDuration
						} ${localizationService.t(
							"PAYMENT_OPTIONS.DURATION_PERIOD.DAY"
						)}`;
						break;
					}
					default: {
						item.displayDepositDuration = localizationService.t(
							"PAYMENT_OPTIONS.DURATION_PERIOD.CUSTOM",
							{ period: `1-${item.depositDuration}` }
						);
						break;
					}
				}

				switch (item.payoutDuration) {
					case 0: {
						item.displayPayoutDuration = localizationService.t(
							"PAYMENT_OPTIONS.DURATION_PERIOD.IMMEDIATELY"
						);
						break;
					}
					case 1: {
						item.displayPayoutDuration = `${
							item.payoutDuration
						} ${localizationService.t(
							"PAYMENT_OPTIONS.DURATION_PERIOD.DAY"
						)}`;
						break;
					}
					default: {
						item.displayPayoutDuration = localizationService.t(
							"PAYMENT_OPTIONS.DURATION_PERIOD.CUSTOM",
							{ period: `1-${item.payoutDuration}` }
						);
						break;
					}
				}

				return item;
			}
		);

		const paymentOptionsData = new PaymentOptionsData();
		paymentOptionsData.depositList = mappedResponse.filter(
			(paymentOption) => paymentOption.depositEnabled
		);
		paymentOptionsData.withdrawList = mappedResponse.filter(
			(paymentOption) => paymentOption.payoutEnabled
		);

		return paymentOptionsData;
	}
}

export default new PaymentOptionsService();
